(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      document.addEventListener('click', this.closeHeaderDropdownOnOutsideClick.bind(this));
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    closeHeaderDropdownOnOutsideClick(event) {
      const openDrawer = document.querySelector('header-drawer details[open]');
      if (!openDrawer) return;

      if (!openDrawer.contains(event.target)) {
        openDrawer.removeAttribute('open');
        openDrawer.classList.remove('menu-opening');
      }
    }

    disconnectedCallback() {}
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
